import store from "../store";

export default {
    beforeRouteEnter(to, from, next) {
        if (
            store.state.authenticatedUser &&
            store.state.authenticatedUserAccess != "full"
        ) {
            next();
        } else {
            next({ name: "home" });
        }
    }
};
